import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { galleryListQueries } from '@/services/galleryManagement/galleryManagement.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useAddStoreGallery = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('createHostGallery', {
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: galleryListQueries.all() });
      toast.success(data.message);
      await revalidate(['hostDetail', 'clubHosts', 'clubBasicInfo', 'all']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
